<template>
	<div>
		<h3>
			<q-icon class="icon-fleche"/>
			Soutenez les activistes
		</h3>

		<p>
			Pour alerter sur la déforestation importée, nos activistes sont perché·es au-dessus du vide et harnaché·es sur un site Seveso&nbsp;: la raffinerie de la Mède. Ils bloquent ce site pour dénoncer l’hypocrisie du gouvernement, qui a autorisé Total à y importer jusqu’à 650&nbsp;000 tonnes d’huile de palme par an&nbsp;: une hérésie&nbsp;!
		</p>
		<p>
			Envoyez un mail aux activistes&nbsp;: ils pourront le lire sur leur téléphone. Chaque encouragement compte&nbsp;!
		</p>
		<p class="text-center q-mb-lg q-pb-lg">
			<q-btn class="btn-main q-mt-lg"
				label="J’envoie un mail aux activistes"
				@click="track"
				href="mailto:activistes-lamede@greenpeace.fr"/>
		</p>

	</div>
</template>

<script>
export default {
	methods: {
		track() {
			this.$count()
			this.$trackEvent("click", "mail activistes")
			//location.href = "mailto:activistes-lamede@greenpeace.fr"
		},
	}
}
</script>